<template>
  <v-app id="app">
    <v-navigation-drawer app clipped v-model="drawer" style="background-color: #212121;">
      <v-list-item>
          <v-list-item-content>
            <v-list-item-title align="center">
              <v-row justify="center" no-gutters>
                <v-col align="center">
                  <v-img src="@/assets/icon.svg" alt="Logo" contain position="center" height="50px"/>
                </v-col>     
              </v-row>
              <v-row justify="center" no-gutters>
                <v-col align="center">
                  <span class="info--text">{{ user.companyName ? user.companyName : user.firstName + ' ' + user.lastName }}</span> <br/> 
                  <span v-if="userRole != 'client'" class="primary--text"> Dashboard </span> 
                </v-col>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="grey darken-1"></v-divider>
        <v-list nav v-if="userRole != 'client'">
          <v-list-item v-for="(route, idx) of userNavRoutes"  :key="idx">
            <v-row justify="center">
              <v-btn min-width="90%" raised color="primary" :href="route.path">{{ route.title }}</v-btn>
            </v-row>
          </v-list-item>
        </v-list>
        <v-list nav v-if="userRole == 'client'">
          <v-list-item-group>
            <v-list-item href="/dashboard/create"> 
              <v-row justify="start" no-gutters>
                <v-col align="start" no-gutters>
                  <v-list-item-content>
                    <v-list-item-title :class="this.$router.currentRoute.fullPath == '/dashboard/create' ? 'primary--text' : 'info--text'"> <v-icon :class="this.$router.currentRoute.fullPath == '/dashboard/create' ? 'primary--text mr-2' : 'info--text mr-2'"> mdi-cube-outline </v-icon> Book / Quote</v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <h3 class="white--text my-4">Bookings</h3>
            <v-list-item to="/dashboard/bookings"> 
              <v-row justify="start" no-gutters>
                <v-col align="start" no-gutters>
                  <v-list-item-content>
                    <v-list-item-title :class="this.$router.currentRoute.fullPath == '/dashboard/bookings' ? 'primary--text' : 'info--text'"> <v-icon :class="this.$router.currentRoute.fullPath == '/dashboard/bookings' ? 'primary--text mr-2' : 'info--text mr-2'"> mdi-truck-fast-outline </v-icon> Active Bookings <span class="primary--text">({{ bookings.length }})</span></v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item to="/dashboard/bookingList"> 
              <v-row justify="start" no-gutters>
                <v-col align="start" no-gutters>
                  <v-list-item-content>
                    <v-list-item-title :class="this.$router.currentRoute.fullPath == '/dashboard/bookingList' ? 'primary--text' : 'info--text'"> <v-icon :class="this.$router.currentRoute.fullPath == '/dashboard/bookingList' ? 'primary--text mr-2' : 'info--text mr-2'"> mdi-format-list-checkbox </v-icon> Booking List</v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item href="/dashboard/trackBookings"> 
              <v-row justify="start" no-gutters>
                <v-col align="start" no-gutters>
                  <v-list-item-content>
                    <v-list-item-title :class="this.$router.currentRoute.fullPath == '/dashboard/trackBookings' ? 'primary--text' : 'info--text'"> <v-icon :class="this.$router.currentRoute.fullPath == '/dashboard/trackBookings' ? 'primary--text mr-2' : 'info--text mr-2'"> mdi-map-marker </v-icon> Track Bookings</v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item to="/dashboard/BookingHistory"> 
              <v-row justify="start" no-gutters>
                <v-col align="start" no-gutters>
                  <v-list-item-content>
                    <v-list-item-title :class="this.$router.currentRoute.fullPath == '/dashboard/BookingHistory' ? 'primary--text' : 'info--text'"> <v-icon :class="this.$router.currentRoute.fullPath == '/dashboard/BookingHistory' ? 'primary--text mr-2' : 'info--text mr-2'"> mdi-truck-check-outline </v-icon> Completed Bookings</v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <h3 class="white--text my-4"> Quotes </h3>
            <v-list-item href="/dashboard/quotes"> 
              <v-row justify="start" no-gutters>
                <v-col align="start" no-gutters>
                  <v-list-item-content>
                    <v-list-item-title :class="this.$router.currentRoute.fullPath == '/dashboard/quotes' ? 'primary--text' : 'info--text'"> <v-icon :class="this.$router.currentRoute.fullPath == '/dashboard/quotes' ? 'primary--text mr-2' : 'info--text mr-2'"> mdi-script-text-outline </v-icon> Active Quotes </v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-divider class="grey darken-1 my-4"></v-divider>
            <v-list-item href="/dashboard/profile"> 
              <v-row justify="start" no-gutters>
                <v-col align="start" no-gutters>
                  <v-list-item-content>
                    <v-list-item-title :class="this.$router.currentRoute.fullPath == '/dashboard/profile' ? 'primary--text' : 'info--text'"> <v-icon :class="this.$router.currentRoute.fullPath == '/dashboard/profile' ? 'primary--text mr-2' : 'info--text mr-3'"> mdi-card-account-details </v-icon>My Profile </v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item href="/dashboard/logout"> 
              <v-row justify="start" no-gutters>
                <v-col align="start" no-gutters>
                  <v-list-item-content>
                    <v-list-item-title :class="this.$router.currentRoute.fullPath == '/dashboard/logout' ? 'primary--text' : 'info--text'"> <v-icon :class="this.$router.currentRoute.fullPath == '/dashboard/logout' ? 'primary--text mr-2' : 'info--text mr-3'"> mdi-logout </v-icon>Log Out</v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list-item-group>
        </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-btn tile elevation="0" style="border-bottom-right-radius: 5px; position: fixed; z-index: 1;" class="grey darken-3 primary--text" @click="drawer = !drawer"><v-icon large>{{ drawer ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon></v-btn>
      <br/>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: "Dashboard",
  data() {
    return {
      drawer: null,
      userNavRoutes: [],
      navRoutes: [
        {
          path: '/dashboard/driverBookings',
          title: 'My bookings',
          roles: ['driver']
        },{
          path: '/dashboard/graph',
          title: 'Graph',
          roles: ['admin']
        },{
          path: '/dashboard/scheduledBookings',
          title: 'SCHEDULED',
          roles: ['admin']
        },{
          path: '/dashboard/adminBookings',
          title: 'Bookings',
          roles: ['admin']
        },{
          path: '/dashboard/serviceProviderArea',
          title: 'Service Areas',
          roles: ['admin']
        },{
          path: '/dashboard/wasteType',
          title: 'Waste Types',
          roles: ['admin']
        },{
          path: '/dashboard/vehicleType',
          title: 'Vehicle Types',
          roles: ['admin']
        },{
          path: '/dashboard/drivers',
          title: 'Drivers',
          roles: ['admin']
        },{
          path: '/dashboard/users',
          title: 'Users',
          roles: ['admin']
        },{
          path: '/dashboard/adminDisposals',
          title: 'Disposals',
          roles: ['admin']
        },{
          path: '/dashboard/driverDisposals',
          title: 'Disposals',
          roles: ['driver']
        },{
          path: '/dashboard/pastOrders',
          title: 'Past Orders',
          roles: ['driver']
        },{
          path: '/dashboard/logout',
          title: 'Logout',
          roles: ['admin', 'driver']
        }
      ],
      loaded: false,
      showLoader: false
    }
  },
  computed: {
    bookings() {
      return this.$store.getters.getBookings;
    },
    userToken() {
      return this.$store.getters['auth/getToken'];
    },
    userRole() {
      if (this.$store.getters['auth/isAdmin'])
        return 'admin';
      else if (this.$store.getters['auth/isDriver'])
        return 'driver';
      else if (this.$store.getters['auth/isClient'])
        return 'client';
      else return false
    },
    user(){
      return this.$store.getters['auth/getUser'];
    }
  },
  methods: {
    filterRoutes() {
      this.userNavRoutes = this.navRoutes.filter((route) => {
        return route.roles.includes(this.userRole);
      });
    }
  },
  mounted() {
    this.filterRoutes();
    this.$store.dispatch('driver/fetchDrivers');
    if(this.bookings.length < 1) {
      this.$store.dispatch('fetchClientBookings', this.user.id);
    }
  }
}
</script>

<style scoped lang="scss">
</style>